
import * as React from "react";
import styles from "./Title.scss";

export type ITitle_Props = {
  children: React.ReactNode;
};

class Title extends React.PureComponent<ITitle_Props, any> {

  render() {
    return <span className={styles.title}>
                {this.props.children}
            </span>;
  }
}

export default Title;